import { useHistory, useLocation } from 'react-router-dom';
import { useCallback, useMemo } from 'react';
import qs from 'qs';

export function useTabState<T extends string>(tabName: string, defaultTab: T): [T, (tabName: string) => void] {

    if (tabName === 'tab') {
        console.warn('useTabState: `tab` is a reserved keyword used in `useDataTableState` please use a different value');
    }

    const history = useHistory();
    const location = useLocation();

    const currentTab = useMemo(() => {
        const params = qs.parse(location.search.substring(1));
        return params[tabName] as T ?? defaultTab;
    }, [location.search, tabName]);

    const setTab = useCallback((value: string) => {
        const params = qs.parse(location.search.substring(1));

        const newParams = {
            /**
             * Persist all values already in the query string
             */
            ...params,
            /**
             * Use new value for tab
             */
            [tabName]: value,
            /**
             * Clear date table state
             * everything below a tab should be cleared when it's clicked, as only one data table can appear on a page
             * we don't want two tabs sharing the same sort & pagination
             */
            page: undefined,
            pageSize: undefined,
            sortField: undefined,
            sortDirection: undefined,
            filters: undefined,
            search: undefined,
            tableTab: undefined,
            tab: undefined
        }

        history.replace(`?${qs.stringify(newParams)}`);
    }, [tabName, location.state, location.search]);

    return [
        currentTab,
        setTab
    ];
}
